import { render, staticRenderFns } from "./FarmingStageModal.vue?vue&type=template&id=06f94e48&"
import script from "./FarmingStageModal.vue?vue&type=script&lang=js&"
export * from "./FarmingStageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports